const defaultPadding = '1.25rem';
const tightPadding = '.5rem';
const loosePadding = '1.5rem';
// TODO: use spacing instead of string in paddingX!!
export function getMainContentPaddingX({ paddingX, tight, loose }) {
    return paddingX ?? (tight ? tightPadding : loose ? loosePadding : defaultPadding);
}
